module.exports = __webpack_public_path__ + "static/media/IMG_4398.dde08c18.JPG";